import { getCorpId } from '@/utils/tool'
import dd from '@/utils/dd.config'
import { _login } from '@/api/user'

const doLogin = () => {
  const corpId = getCorpId() || 'dinged57bd8b6ba53cffbc961a6cb783455b'
  // console.log('corpId', corpId)
    return new Promise((res, rej) => {
      dd.auth(corpId).then(d => {
        const { code } = d
        _login({ code: code, corpId }).then(([success, result]) => {
          if (success) {
            localStorage.setItem('TOKEN', result.token)
            res(result)
          }else {
            rej('nologin')
          }
        })
      }).catch(e => {
        rej(e)
      })
    })
}

export default doLogin
